import ApplicationController from './application_controller'
import Uppy from '@uppy/core'
import Dashboard from '@uppy/dashboard'
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'

export default class extends ApplicationController {
  static targets = ['container', 'packingForm', 'imagePackings']
  static values = { uploadType: String }

  get errorMessages() {
    const locale = document.documentElement.lang || 'fr'
    const messages = {
      fr: {
        tooManyFiles: "Trop de fichiers sélectionnés ({count}). Maximum autorisé: {limit} fichiers.",
        fileSizeExceeded: "Fichier trop volumineux. Taille maximale autorisée: {limit}.",
        invalidFileType: "Type de fichier non autorisé. Formats acceptés: {types}.",
        uploadError: "Trop de fichiers uploadés simultanément. Veuillez réduire le nombre de fichiers."
      },
      en: {
        tooManyFiles: "Too many files selected ({count}). Maximum allowed: {limit} files.",
        fileSizeExceeded: "File too large. Maximum allowed size: {limit}.",
        invalidFileType: "File type not allowed. Accepted formats: {types}.",
        uploadError: "Too many files uploaded simultaneously. Please reduce the number of files."
      }
    }
    return messages[locale] || messages.fr
  }

  connect() {
    this.uploads = []

    this.uppy = new Uppy({
      autoProceed: true,
      allowMultipleUploads: true,
      restrictions: {
        allowedFileTypes: ['image/*', '.jpg', '.jpeg', '.png', '.gif'],
        maxNumberOfFiles: 50,
        maxFileSize: 10 * 1024 * 1024
      }
    })
      .use(Dashboard, {
        target: this.containerTarget,
        hideUploadButton: true,
        proudlyDisplayPoweredByUppy: false,
        inline: true,
        width: '100%'
      })

    this.uppy.on('restriction-failed', (file, error) => {
      console.warn('Upload restriction failed:', error.message)
      let localizedMessage = error.message
      
      if (error.message.includes('exceeds maximum allowed size')) {
        localizedMessage = this.errorMessages.fileSizeExceeded.replace('{limit}', '10MB')
      } else if (error.message.includes('not allowed type')) {
        localizedMessage = this.errorMessages.invalidFileType.replace('{types}', 'images')
      } else if (error.message.includes('cannot add more files')) {
        localizedMessage = this.errorMessages.tooManyFiles.replace('{count}', '50+').replace('{limit}', '50')
      }
      
      this.showUploadError(localizedMessage)
    })
  }

  retrievePictures() {
    this.uppy.getFiles().forEach((uppyFile) => {
      this.uploads.push(uppyFile['data'])
    })

    return this.uploads
  }

  blobToFile(theBlob, fileName) {
    const upload = document.querySelector('[data-controller="resize-uploaded-files"]')
    let controller = this.application.getControllerForElementAndIdentifier(upload, 'resize-uploaded-files')
    const blobFile = eval(controller['blobToFile'](theBlob, fileName))

    return blobFile
  }

  resizePhotos(settings) {
    const upload = document.querySelector('[data-controller="resize-uploaded-files"]')
    let controller = this.application.getControllerForElementAndIdentifier(upload, 'resize-uploaded-files')
    const blobFile = eval(controller['resizePhotos'](settings))

    return blobFile
  }

  async addToFormData(formData, array, requestValue) {
    const upload = document.querySelector('[data-controller="resize-uploaded-files"]')
    let controller = this.application.getControllerForElementAndIdentifier(upload, 'resize-uploaded-files')
    const blobFile = await eval(controller['addToFormData'](formData, array, requestValue))

    return blobFile
  }

  async uploadAfterPacking() {
    this.uploads = this.retrievePictures()

    if (this.uploads.length > 50) {
      const message = this.errorMessages.tooManyFiles
        .replace('{count}', this.uploads.length)
        .replace('{limit}', '50')
      this.showUploadError(message)
      return
    }

    let dataset = event.currentTarget.dataset
    let directlyUploaded = Boolean(dataset.directlyUpload)
    let url = dataset.url
    let body = new FormData()
    let action

    if (this.hasPackingFormTarget) {
      action = this.packingFormTarget
    }

    if (this.hasUploadTypeValue) {
      body = await this.addToFormData(body, this.uploads, `order[${this.uploadTypeValue}_uploads][]`)
    } else {
      body = await this.addToFormData(body, this.uploads, 'order[packing_uploads][]')
    }

    if (this.hasPackingFormTarget) {
      body.append('authenticity_token', action.children[0].value)
    }

    body.append('after_submit', 'true')
    if (directlyUploaded) {
      body.append('directly_uploaded', directlyUploaded)
    }

    if (this.retrievePictures().length >= 0) {
      fetch(url, {
        method: 'PATCH',
        body: body,
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      })
        .then(response => {
          if (!response.ok) {
            return response.json().then(data => Promise.reject(data));
          }
          window.location.reload();
        })
        .catch(error => {
          console.error('Error:', error);
          if (error.message && error.message.includes('multipart')) {
            this.showUploadError(this.errorMessages.uploadError)
          }
        });
    }
  }

  showUploadError(message) {
    let errorContainer = document.querySelector('.upload-error-container')
    if (!errorContainer) {
      errorContainer = document.createElement('div')
      errorContainer.className = 'upload-error-container mt-2'
      this.containerTarget.insertAdjacentElement('afterend', errorContainer)
    }

    errorContainer.innerHTML = `
      <div class="alert alert-danger" role="alert">
        <strong>Upload Error:</strong> ${message}
      </div>
    `

    setTimeout(() => {
      if (errorContainer) {
        errorContainer.remove()
      }
    }, 10000)
  }
}
